/**
 * WebIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const WebIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M12 2.25A9.735 9.735 0 0 1 21.75 12 9.736 9.736 0 0 1 12 21.751 9.736 9.736 0 0 1 2.25 12 9.735 9.735 0 0 1 12 2.25m-3.23 10.5c.119 2.378.798 4.73 2.042 6.806a1.38 1.38 0 0 0 1.164.693l.024.001.026-.001a1.38 1.38 0 0 0 1.164-.693 14.7 14.7 0 0 0 2.041-6.806zm-4.985 0a8.23 8.23 0 0 0 5.422 7.017A16.2 16.2 0 0 1 7.27 12.75zm12.946 0a16.2 16.2 0 0 1-1.938 7.017 8.23 8.23 0 0 0 5.422-7.017zM9.208 4.231a8.23 8.23 0 0 0-5.423 7.019H7.27c.11-2.435.755-4.847 1.938-7.019m3.982.214a1.365 1.365 0 0 0-2.378 0A14.7 14.7 0 0 0 8.77 11.25h6.46a14.7 14.7 0 0 0-1.791-6.371zm1.602-.213a16.2 16.2 0 0 1 1.94 7.018h3.483a8.23 8.23 0 0 0-5.423-7.018"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const WebIcon = makeIcon('WebIcon', WebIconSvg)
